[
    {
      "name": "Teentaal",
      "beats": 16,
      "bols": ["Dha", "Dhin", "Dhin", "Dha", "Dha", "Dhin", "Dhin", "Dha", "Dha", "Tin", "Tin", "Ta", "Ta", "Dhin", "Dhin", "Dha"],
      "vibhags": [
        { "label": "Sum", "beats": [1, 2, 3, 4] },
        { "label": "T2", "beats": [5, 6, 7, 8] },
        { "label": "Khali", "beats": [9, 10, 11, 12] },
        { "label": "T3", "beats": [13, 14, 15, 16] }
      ]
    },
    {
      "name": "Dadra",
      "beats": 6,
      "bols": ["Dha", "Dhi", "Na", "Dha", "Tu", "Na"],
      "vibhags": [
        { "label": "Sum", "beats": [1, 2, 3] },
        { "label": "Khali", "beats": [4, 5, 6] }
      ]
    },
    {
      "name": "Keharwa",
      "beats": 8,
      "bols": ["Dha", "Ge", "Na", "Ti", "Na", "Ka", "Dhi", "Na"],
      "vibhags": [
        { "label": "Sum", "beats": [1, 2, 3, 4] },
        { "label": "Khali", "beats": [5, 6, 7, 8] }
      ]
    },
    {
      "name": "Jhaptal",
      "beats": 10,
      "bols": ["Dhi", "Na", "Dhi", "Dhi", "Na", "Tin", "Na", "Dhi", "Dhi", "Na"],
      "vibhags": [
        { "label": "Sum", "beats": [1, 2] },
        { "label": "", "beats": [3, 4, 5] },
        { "label": "Khali", "beats": [6, 7] },
        { "label": "", "beats": [8, 9, 10] }
      ]
    },
    {
      "name": "Rupak",
      "beats": 7,
      "bols": ["Tin", "Tin", "Na", "Dhin", "Na", "Dhin", "Na"],
      "vibhags": [
        { "label": "Khali", "beats": [1, 2, 3] },
        { "label": "", "beats": [4, 5] },
        { "label": "Sum", "beats": [6, 7] }
      ]
    },
    {
      "name": "Ektaal",
      "beats": 12,
      "bols": ["Dhin", "Dhin", "Dha", "Ge", "Ti", "Na", "Kat", "Ta", "Dhin", "Dhin", "Dha", "Ge"],
      "vibhags": [
        { "label": "Sum", "beats": [1, 2] },
        { "label": "", "beats": [3, 4] },
        { "label": "", "beats": [5, 6] },
        { "label": "Khali", "beats": [7, 8] },
        { "label": "", "beats": [9, 10] },
        { "label": "", "beats": [11, 12] }
      ]
    },
    {
      "name": "Deepchandi",
      "beats": 14,
      "bols": ["Dha", "Dhin", "Dhin", "Dha", "Tin", "Ta", "Tin", "Dha", "Dha", "Dhin", "Dhin", "Dha", "Tin", "Ta"],
      "vibhags": [
        { "label": "Sum", "beats": [1, 2, 3] },
        { "label": "", "beats": [4, 5] },
        { "label": "Khali", "beats": [6, 7, 8] },
        { "label": "", "beats": [9, 10] },
        { "label": "", "beats": [11, 12, 13, 14] }
      ]
    }
  ]
  